import { combineReducers } from "redux";
import { authReducer } from "./auth/authReducer";
import { chuyenNganhReducer } from "./category/chuyenNganhReducer";
import { keHoachNamReducer } from "./category/keHoachNamReducer";
import { lopNamHocReduer } from "./category/lopNamHocReduer";

import { baoCaoReducer } from "./bao-cao/baoCaoReducer";
import { bienLaiPagingReducer } from "./bien-lai/bienLaiPagingReducer";
import { bienLaiViewChiTietReducer } from "./bien-lai/bienLaiViewChiTietReducer";
import { bienLaiViewReducer } from "./bien-lai/bienLaiViewReducer";
import { bienLaiViewTheoLopChiTietReducer } from "./bien-lai/bienLaiViewTheoLopChiTietReducer";
import { bienLaiViewTheoLopReducer } from "./bien-lai/bienLaiViewTheoLopReducer";
import { bienLaiThietLapReducer } from "./category/bienLaiThietLapReducer";
import { chuongTrinhDaoTaoKienThucReducer } from "./category/chuongTrinhDaoTaoKienThucReducer";
import { coSoReducer } from "./category/coSoReducer";
import { dotTuyenSinhReducer } from "./category/dotTuyenSinhReducer";
import { heReducer } from "./category/heReducer";
import { hinhThucNopTienReducer } from "./category/hinhThucNopTienReducer";
import { hocKyDangKyReducer } from "./category/hocKyDangKyReducer";
import { khoaReducer } from "./category/khoaReducer";
import { loaiThuChiReducer } from "./category/loaiThuChiReducer";
import { loaiThuNhapHocReducer } from "./category/loaiThuNhapHocReducer";
import { mucHocPhiTinChiReducer } from "./category/mucHocPhiTinChiReducer";
import { nganhReducer } from "./category/nganhReducer";
import { nhomLoaiThuChiReducer } from "./category/nhomLoaiThuChiReducer";
import { layoutReducer } from "./common/layoutReducer";
import { danhSachLopTinChiReducer } from "./lop-tin-chi/danhSachLopTinReducer";
import { planLopTinChiReducer } from "./lop-tin-chi/planLopTinChiReducer";
import { danhSachMienGiamReducer } from "./mien-giam/danhSachMienGiamReducer";
import { hinhThucChiTietReducer } from "./mien-giam/hinhThucChiTietReducer";
import { hinhThucReducer } from "./mien-giam/hinhThucReducer";
import { hinhThucTinhReducer } from "./mien-giam/hinhThucTinhReducer";
import { mucThuReducer } from "./mucThu/mucThuReducer";
import { mucThuTamThuReducer } from "./mucThu/mucThuTamThuReducer";
import { mucThuTinChiReducer } from "./mucThu/mucThuTinChiReducer";
import { reportNhapHocReducer } from "./report/reportNhapHocReducer";
import { reportReducer } from "./report/reportReducer";
import { reportTamThuReducer } from "./report/reportTamThuReducer";
import { thuPhiNhapHocReducer } from "./thu-phi-nhap-hoc/thuPhiNhapHocReducer";
import { thuPhiTamThuReducer } from "./thu-phi-tam-thu/thuPhiTamThuReducer";
import { thuPhiReducer } from "./thu-phi/thuPhiReducer";
import { thuPhiTheoLopReducer } from "./thu-phi/thuPhiTheoLopReducer";
import { khoiNganhReducer } from "./category/khoiNganhReducer";
import { bieuDoReducer } from "./bieu-do/bieuDoReducer";
import { loaiThuTuyenSinhReducer } from "./category/loaiThuTuyenSinhReducer";
import { hoaDonDienTuReducer } from "./hoa-don/hoaDonDienTuReducer";
import { thuPhiTuyenSinhReducer } from "./thu-phi-tuyen-sinh/thuPhiTuyenSinhReducer";
import { bienLaiViewTuyenSinhReducer } from "./bien-lai/bienLaiViewTuyenSinhReducer";
import { importTuyenSinhReducer } from "./thu-phi-tuyen-sinh/importTuyenSinhReducer";
import { nganHangReducer } from "./ngan-hang/nganHangReducer";
import { voucherReducer } from "./category/voucherReducer";
import { configInvoiceReducer } from "./category/configInvoiceReducer";
import { tongHopSinhVienReducer } from "./report/tongHopSinhVienReducer";
import { trangThaiHocReducer } from "./category/trangThaiHocReducer";
import { dongBoPhiKyTucXaReducer } from "./dong-bo/dongBoPhiKyTucXaReducer";
import { dongBoHocPhiReducer } from "./dong-bo/dongBoHocPhiReducer";
import { kyHieuHoaDonReducer } from "./hoa-don/kyHieuHoaDonReducer";
import { dongBoCongNoReducer } from "./dong-bo/dongBoCongNoReducer";
import { heSoLopTuNguyenReducer } from "./thiet-lap/heSoLopTuNguyenReducer";
import { dichVuHoSoReducer } from "./dich-vu/dichVuHoSoReducer";
import { dichVuThanhToanReducer } from "./dich-vu/dichVuThanhToanReducer";
import { dichVuThongTinReducer } from "./dich-vu/dichVuThongTinReducer";

const reducers = combineReducers({
  auth: authReducer,
  common: combineReducers({
    layout: layoutReducer,
  }),
  category: combineReducers({
    loaiThuChi: loaiThuChiReducer,
    mucHocPhiTinChi: mucHocPhiTinChiReducer,
    nganh: nganhReducer,
    chuyenNganh: chuyenNganhReducer,
    keHoachNam: keHoachNamReducer,
    he: heReducer,
    lopNamHoc: lopNamHocReduer,
    chuongTrinhDaoTaoKienThuc: chuongTrinhDaoTaoKienThucReducer,
    nhomLoaiThuChi: nhomLoaiThuChiReducer,
    hinhThucNopTien: hinhThucNopTienReducer,
    hocKyDangKy: hocKyDangKyReducer,
    khoa: khoaReducer,
    bienLaiThietLap: bienLaiThietLapReducer,
    dotTuyenSinh: dotTuyenSinhReducer,
    loaiThuNhapHoc: loaiThuNhapHocReducer,
    loaiThuTuyenSinh: loaiThuTuyenSinhReducer,
    coSo: coSoReducer,
    khoiNganh: khoiNganhReducer,
    voucher: voucherReducer,
    configInvoice: configInvoiceReducer,
    trangThaiHoc: trangThaiHocReducer,
  }),
  nganHang: combineReducers({
    nganHang: nganHangReducer,
  }),
  mucThu: combineReducers({
    mucThu: mucThuReducer,
    mucThuTinChi: mucThuTinChiReducer,
    mucThuTamThu: mucThuTamThuReducer,
  }),
  mienGiam: combineReducers({
    hinhThuc: hinhThucReducer,
    hinhThucChiTiet: hinhThucChiTietReducer,
    hinhThucTinh: hinhThucTinhReducer,
    danhSachMienGiam: danhSachMienGiamReducer,
  }),
  thuPhi: combineReducers({
    thuPhi: thuPhiReducer,
    thuPhiTheoLop: thuPhiTheoLopReducer,
    thuPhiNhapHoc: thuPhiNhapHocReducer,
    thuPhiTuyenSinh: thuPhiTuyenSinhReducer,
    importTuyenSinh: importTuyenSinhReducer,
    thuPhiTamThu: thuPhiTamThuReducer,
  }),
  bienLai: combineReducers({
    bienLaiView: bienLaiViewReducer,
    bienLaiViewTuyenSinh: bienLaiViewTuyenSinhReducer,
    bienLaiViewTheoLop: bienLaiViewTheoLopReducer,
    bienLaiViewChiTiet: bienLaiViewChiTietReducer,
    bienLaiViewTheoLopChiTiet: bienLaiViewTheoLopChiTietReducer,
    bienLaiPaging: bienLaiPagingReducer,
  }),
  hoaDon: combineReducers({
    hoaDonDienTu: hoaDonDienTuReducer,
    kyHieuHoaDon: kyHieuHoaDonReducer,
  }),
  report: combineReducers({
    report: reportReducer,
    reportNhapHoc: reportNhapHocReducer,
    reportTamThu: reportTamThuReducer,
    sinhVien: tongHopSinhVienReducer,
  }),
  lopTinChi: combineReducers({
    planLopTinChi: planLopTinChiReducer,
    danhSachLopTinChi: danhSachLopTinChiReducer,
  }),
  baoCao: combineReducers({
    baoCao: baoCaoReducer,
  }),
  bieuDo: combineReducers({
    bieuDo: bieuDoReducer,
  }),
  dongBo: combineReducers({
    hocPhi: dongBoHocPhiReducer,
    kyTucXa: dongBoPhiKyTucXaReducer,
    congNo: dongBoCongNoReducer,
  }),
  thietLap: combineReducers({
    heSoLopTuNguyen: heSoLopTuNguyenReducer,
  }),
  dichVu: combineReducers({
    hoSo: dichVuHoSoReducer,
    thanhToan: dichVuThanhToanReducer,
    thongTin: dichVuThongTinReducer,
  }),
});

export default reducers;

export type RootState = ReturnType<typeof reducers>;
